<template>
	<v-sheet elevation="0">
		<!-- <FunctionTitle :title="mainTitle" /> -->
		<CommonFlame :title="pageTitle" class="mt-2">
			<template v-if="!$vuetify.breakpoint.xs" v-slot:app-bar-btn>
				<DailyReportSearchDialog
					ref="searchDialog"
					:query.sync="q"
					:open.sync="openSearchDialog"
					:users="users"
					:templates="templates"
					:date_range.sync="dateRange"
					text
					@search-reports="searchReports($event)"
				/>
				<v-menu offset-y max-height="60vh">
					<template v-slot:activator="{ on, attrs }">
						<v-btn text dark v-bind="attrs" v-on="on">
							<v-icon class="mr-2">mdi-plus</v-icon>
							新規日報
						</v-btn>
					</template>
					<v-list>
						<v-list-item
							v-for="template in filteredTemplates"
							:key="template.id"
							@click="
								$router.push({
									name: 'template_daily_report_new',
									params: { template_id: template.id },
								})
							"
						>
							<v-list-item-title>{{ template.name }}</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-menu>
			</template>
			<template v-if="$vuetify.breakpoint.xs">
				<v-row no-gutters class="mb-2" justify="end">
					<DailyReportSearchDialog
						ref="searchDialog"
						:query.sync="q"
						:open.sync="openSearchDialog"
						:users="users"
						:templates="templates"
						:date_range.sync="dateRange"
						@search-reports="searchReports($event)"
					/>
					<v-menu offset-y>
						<template v-slot:activator="{ on, attrs }">
							<v-btn color="secondary" dark v-bind="attrs" v-on="on">
								<v-icon class="mr-2">mdi-plus</v-icon>
								新規日報
							</v-btn>
						</template>
						<v-list>
							<v-list-item
								v-for="template in templates"
								:key="template.id"
								@click="
									$router.push({
										name: 'template_daily_report_new',
										params: { template_id: template.id },
									})
								"
							>
								<v-list-item-title>{{ template.name }}</v-list-item-title>
							</v-list-item>
						</v-list>
					</v-menu>
				</v-row>
			</template>

			<div class="table-container px-2 mt-4">
				<v-data-table
					locale="ja-JP"
					:headers="headers"
					:items="reports"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item }">
						<tr @click="showDialog(item)" class="clickable">
							<td>{{ item.report_date | dateFormatter }}</td>
							<td>{{ item.start_at | timeFormatter }}〜{{ item.end_at | timeFormatter }}</td>
							<td>{{ truncate(item.title, 10) }}</td>
							<td>{{ item.user_name }}</td>
							<td>{{ item.daily_report_template ? item.daily_report_template.name : "" }}</td>
						</tr>
					</template>
				</v-data-table>

				<PaginationModule :pagination="pagination" @get-page="getPage($event)" />
				<DailyReportShowDialog
					:open="open"
					:dailyReport="report"
					@close="closeDialog"
					@delete-report="deleteReport($event)"
				/>
			</div>
		</CommonFlame>
	</v-sheet>
</template>

<script>
import moment from "moment/min/moment.min.js"
import axios from "axios"
import Qs from "qs"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import DailyReportShowDialog from "./components/DailyReportShowDialog.vue"
import DailyReportSearchDialog from "./components/DailyReportSearchDialog.vue"
import PaginationModule from "../shared/PaginationModule.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"
import CommonFlame from "../shared/CommonFlame.vue"

export default {
	components: {
		DailyReportShowDialog,
		DailyReportSearchDialog,
		PaginationModule,
		FunctionTitle,
		CommonFlame,
	},
	filters: {
		dateFormatter(date) {
			return moment(date).format("YYYY/MM/DD")
		},
		timeFormatter(time) {
			return moment(time).format("HH:mm")
		},
	},

	data() {
		return {
			mainTitle: "日報",
			pageTitle: "日報一覧",
			department_id: this.$route.params.department_id,
			department: { id: null, name: null },
			reports: [],
			headers: [
				{ text: "日付", value: "date", width: "150px", divider: true },
				{ text: "時間", value: "time", width: "150px", divider: true },
				{ text: "件名", value: "title", width: "150px", divider: true },
				{ text: "作成者", value: "matter_name", width: "150px", divider: true },
				{ text: "日報テンプレート名", value: "template.name", width: "150px", divider: true },
			],
			q: {
				report_date_gteq: null,
				report_date_lteq: null,
				title_cont: null,
				user_id_eq: null,
				matter_id_not_null: null,
				daily_report_template_id_eq: null,
			},
			users: [],
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			dateRange: [],
			report: {},
			templates: [],
			open: false,
			openSearchDialog: false,
			showFilters: false,
		}
	},
	mounted() {
		authenticate.authenticateUser()
		this.setQuery()
		const page = this.$route.query.page ? this.$route.query.page : 1
		this.fetchReports(true, page)
	},
	methods: {
		fetchReports(first_visit, page) {
			this.q.report_date_gteq = null
			this.q.report_date_lteq = null
			if (this.dateRange.length) {
				const firstDate = this.dateRange[0]
				const lastDate = this.dateRange[this.dateRange.length - 1]
				if (firstDate > lastDate) {
					this.q.report_date_gteq = lastDate
					this.q.report_date_lteq = firstDate
				} else {
					this.q.report_date_gteq = firstDate
					this.q.report_date_lteq = lastDate
				}
			}

			const headers = authenticate.setHeader()
			const url = `/erp/v1/departments/${this.department_id}/daily_reports`
			const params = { q: this.q, page, first_visit }
			const paramsSerializer = (params) => Qs.stringify(params, { arrayFormat: "brackets" })
			axios
				.get(url, { headers, params, paramsSerializer })
				.then((res) => {
					this.reports = res.data.daily_reports
					this.pagination = res.data.pagination
					if (first_visit) {
						this.department = res.data.department
						this.templates = res.data.templates
						this.users = res.data.users
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		setQuery() {
			const query = this.$route.query
			if (query) {
				Object.keys(this.$route.query).forEach((query_key) => {
					if (query[query_key] && query_key != "page") {
						this.q[query_key] = this.formatQuery(query[query_key])
					}
				})
				if (this.q.report_date_gteq) this.dateRange.push(this.q.report_date_gteq)
				if (this.q.report_date_lteq) this.dateRange.push(this.q.report_date_lteq)
				this.$refs.searchDialog.dates = this.dateRange
			} else {
				const today = new Date()
				const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate())
				this.dateRange.push(moment(lastMonth).format("YYYY-MM-DD"))
				this.dateRange.push(moment(today).format("YYYY-MM-DD"))
			}
		},
		searchReports() {
			this.fetchReports(false, 1)
			this.$router.push({
				name: "daily_report_index",
				query: { ...this.q, page: 1 },
				params: { department_id: this.department_id },
			})
		},
		getPage(i) {
			this.fetchReports(false, i)
			this.$router.push({
				name: "daily_report_index",
				query: { ...this.q, page: i },
				params: { department_id: this.department_id },
			})
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			})
		},
		showDialog(e) {
			if (this.report?.id != e.id) {
				const headers = authenticate.setHeader()
				const url = `/erp/v1/daily_reports/${e.id}`
				axios
					.get(url, { headers })
					.then((res) => {
						this.report = res.data
						this.open = true
					})
					.catch((err) => {
						errorHandling.errorResponse(err)
					})
			} else {
				this.open = true
			}
		},
		closeDialog() {
			this.open = false
		},
		deleteReport(id) {
			this.reports = this.reports.filter((report) => report.id != id)
			this.open = false
		},
	},
	computed: {
		formatQuery() {
			return (query) => {
				if (query instanceof Array) {
					return query.map((v) => (isFinite(v) ? Number(v) : v))
				} else if (isFinite(query)) {
					return Number(query)
				} else {
					return query
				}
			}
		},

		truncate() {
			return (str, len) => {
				return str.length <= len ? str : str.substr(0, len) + "..."
			}
		},
		filteredTemplates() {
			return this.templates.filter((t) => t.status == "available")
		},
	},
}
</script>

<style scoped lang="scss">
@import "../../stylesheet/variable.scss";

.table-container {
	width: 100%;
	overflow-x: scroll;
	.v-data-table {
		width: auto;
	}
}
.container-with-border {
	border: $border-line;
	border-radius: 4px;
}

td {
	white-space: pre-wrap;
}
.v-date-picker-table {
	height: auto;
}
</style>
